<!--右下角浮动按钮组：购物车，客服，回到顶部，支持动态配置-->
<template>
	<div class="float-btns" v-if="showFloatMenu">
		<div class="float-btn-border">
			<div v-for="(item, index) in visibleMenuList" :key="index" class="float-action-btn" :title="item.name" @click="handleMenuClick(item)">
				<el-badge v-if="isCartItem(item)" :hidden="shopCartCount<=0" :value="shopCartCount" :max="99">
					<img :src="getIconUrl(item.icon, item)" @error="handleIconError($event, item)" />
				</el-badge>
				<img v-else :src="getIconUrl(item.icon, item)" @error="handleIconError($event, item)" />
			</div>
		</div>
		<div class="float-action-btn top-btn float-btn-border" v-if="showTop" @click="toTop">
			<img src="../../assets/images/icon-top.png" />
		</div>
	</div>
</template>

<script>
	import { getShoppingCartCount } from '../../utils/api-utils/api-goods-shoppingcart.js';
	import { getParam } from '../../utils/api-utils/api-params.js';
	export default {
		name: 'float-btns',
		props: {
			scrollTarget:{
				type: String,
				default: ""
			} // 监听触发滚动的对象Id，默认整个页面
		},
		data(){
			return{
				shopCartCount: 0, //购物车数量
				topShow: false, // 是否显示回到顶部按钮
				showFloatMenu: false, // 是否显示悬浮菜单
				visibleMenuList: [], // 可见菜单列表
				afterSalesPic: '', // 售后二维码图片
				afterSalesTel: '', // 售后联系电话
			}
		},
		computed: {
			showTop() {
				return this.topShow;
			}
		},
		async created(){
			//获取购物车数量
			this.countShopCart();
			// 加载悬浮菜单配置
			await this.loadMenuConfig();
		},
		mounted(){
			//监听页面滚动距离，显示浮动按钮
			let scrollTargetView = this.scrollTarget ? document.getElementById(this.scrollTarget) : window;
			if (scrollTargetView) {
				scrollTargetView.addEventListener("scroll", this.handleScroll);
			}
			
			//监听购物车数量变化
			this.$eventBus.$on("updateFloatShopCartCount",(data)=>{
				this.shopCartCount = data ? data : 0;
			});

			// 监听登录状态变化，重新加载购物车数量
			this.$eventBus.$on("setCustomerId", async () => {
				await this.countShopCart();
			});
		},
		beforeDestroy(){
			//组件销毁前，取消监听滚动事件
			let scrollTargetView = document.getElementById(this.scrollTarget) || window;
			scrollTargetView.removeEventListener("scroll",this.handleScroll);
			
			//取消监听购物车数量变化
			this.$eventBus.$off("updateFloatShopCartCount");
			this.$eventBus.$off("setCustomerId");
		},
		methods:{
			//获取菜单类型对应的默认图标
			getDefaultIcon(item) {
				if (this.isCartItem(item)) return require('../../assets/images/float-btn/shopCart.png');
				if (item && item.effectType === 'contact') return require('../../assets/images/float-btn/telephone.png');
				if (item && item.effectType === 'aftersales') return require('../../assets/images/float-btn/onlineServices.png');
				return require('../../assets/images/float-btn/menu.png');
			},
			//判断是否为后台配置的默认图标
			isDefaultIcon(icon) {
				if (!icon || typeof icon !== 'string') return true;
				const normalizedIcon = icon.toLowerCase().split('?')[0];
				return normalizedIcon === '/images/dataanalysis/shopcart.png' ||
					normalizedIcon === '/images/dataanalysis/share.png' ||
					normalizedIcon === '/images/dataanalysis/telephone.png' ||
					normalizedIcon === '/images/dataanalysis/menu.png' ||
					normalizedIcon === '/images/dataanalysis/onlineservices.png' ||
					normalizedIcon === 'shopcart.png' ||
					normalizedIcon === 'share.png' ||
					normalizedIcon === 'telephone.png' ||
					normalizedIcon === 'menu.png' ||
					normalizedIcon === 'onlineservices.png';
			},
			//获取图标完整URL
			getIconUrl(icon, item) {
				if (this.isDefaultIcon(icon)) return this.getDefaultIcon(item);
				return icon;
			},
			//图片加载失败时回退到本地图标
			handleIconError(event, item) {
				const image = event && event.target;
				const fallbackIcon = this.getDefaultIcon(item);
				if (image && image.src !== fallbackIcon) {
					image.src = fallbackIcon;
				}
			},
			handleScroll() {
				var scrollHeight = 0;
				if(this.scrollTarget){
					var el = document.getElementById(this.scrollTarget);
					if (el) {
						scrollHeight = el.scrollTop;
					}
				} else {
					scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
				}
				this.topShow = scrollHeight > 100;
			},
			//判断是否是购物车菜单项
			isCartItem(item) {
				return item.effectType === 'builtin' && item.effectValue === 'cart';
			},
			//规范化URL，确保带有协议前缀
			normalizeUrl(url) {
				if (!url) return url;
				// 已经有协议前缀，直接返回
				if (/^https?:\/\//i.test(url)) {
					return url;
				}
				// 以 // 开头的协议相对URL，直接返回
				if (url.startsWith('//')) {
					return url;
				}
				// 其他情况（如 www.baidu.com 或 /path），默认添加 https://
				return 'https://' + url;
			},
			//加载悬浮菜单配置
			async loadMenuConfig() {
				try {
					// 并行获取所有需要的配置
					const params = await getParam('pc_floatingMenuConfig,pc_afterSalesPic,pc_afterSalesTel');
					
					// 保存售后配置
					this.afterSalesPic = params.pc_afterSalesPic || '';
					this.afterSalesTel = params.pc_afterSalesTel || '';
					
					// 解析悬浮菜单配置
					if (params.pc_floatingMenuConfig) {
						try {
							const menuList = JSON.parse(params.pc_floatingMenuConfig);
							// 过滤显示的菜单，并按sort排序
							this.visibleMenuList = menuList
								.filter(item => item.isShow && item.name)
								.sort((a, b) => (a.sort || 999) - (b.sort || 999));
							this.showFloatMenu = this.visibleMenuList.length > 0;
						} catch (e) {
							this.useDefaultConfig();
						}
					} else {
						this.useDefaultConfig();
					}
				} catch (e) {
					this.useDefaultConfig();
				}
			},
			//使用默认配置
			useDefaultConfig() {
				this.visibleMenuList = [
					{ name: '购物车', icon: require('../../assets/images/float-btn/shopCart.png'), effectType: 'builtin', effectValue: 'cart', isShow: true },
					{ name: '售后服务', icon: require('../../assets/images/float-btn/onlineServices.png'), effectType: 'aftersales', effectValue: '', isShow: true }
				];
				this.showFloatMenu = true;
			},
			//处理菜单点击
			handleMenuClick(item) {
				switch(item.effectType) {
					case 'builtin':
						if (item.effectValue === 'cart') {
							this.toShopCart();
						}
						break;
					case 'aftersales':
						this.showAfterSalesDialog(item);
						break;
					case 'contact':
						this.showContactDialog(item.effectValue);
						break;
					case 'custom':
						// 自定义外链，新标签页打开
						if (item.effectValue) {
							var url = this.normalizeUrl(item.effectValue);
							window.open(url, '_blank');
						} else {
							this.$message.warning('未设置链接地址');
						}
						break;
				}
			},
			//跳转购物车页面
			toShopCart(){
				this.$router.push({name:'shopcart'});
			},
			//回到页面顶部
			toTop(){
				if(this.scrollTarget){
					var el = document.getElementById(this.scrollTarget);
					if (el) {
						el.scrollTop = 0;
					}
				} else {
					document.documentElement.scrollTop = 0;
					document.body.scrollTop = 0;
				}
			},
			//获取购物车数量
			async countShopCart(){
				try {
					let shopCartCount = await getShoppingCartCount();
					this.shopCartCount = shopCartCount || 0;
				} catch (e) {
					this.shopCartCount = 0;
				}
			},
			//显示联系我们弹窗
			showContactDialog(tel) {
				if (!tel) {
					this.$message.warning('暂无联系电话');
					return;
				}
				this.$msgbox({
					title: '联系我们',
					message: `<div style="text-align:center;">
						<p style="font-size:14px;color:#666;margin-bottom:15px;">联系电话</p>
						<p style="font-size:24px;color:#409EFF;font-weight:bold;">${tel}</p>
					</div>`,
					dangerouslyUseHTMLString: true,
					showCancelButton: true,
					confirmButtonText: '拨打',
					cancelButtonText: '关闭',
					confirmButtonClass: 'el-button--primary'
				}).then(() => {
					// 拨打电话
					window.location.href = `tel:${tel}`;
				}).catch(() => {});
			},
			//显示售后弹窗
			showAfterSalesDialog(item) {
				// 优先使用全局售后电话，其次使用菜单配置中的effectValue
				var tel = this.afterSalesTel || (item && item.effectValue);
				
				if (this.afterSalesPic) {
					// 显示售后二维码图片
					this.$msgbox({
						title: '售后服务',
						message: `<div style="text-align:center;">
							<img src="${this.afterSalesPic}" style="max-width:300px;max-height:400px;" />
						</div>`,
						dangerouslyUseHTMLString: true,
						showCancelButton: false,
						confirmButtonText: '关闭'
					});
				} else if (tel) {
					// 没有图片但有电话，显示电话
					this.$msgbox({
						title: '售后服务',
						message: `<div style="text-align:center;">
							<p style="font-size:14px;color:#666;margin-bottom:15px;">售后服务电话</p>
							<p style="font-size:24px;color:#409EFF;font-weight:bold;">${tel}</p>
						</div>`,
						dangerouslyUseHTMLString: true,
						showCancelButton: true,
						confirmButtonText: '拨打',
						cancelButtonText: '关闭',
						confirmButtonClass: 'el-button--primary'
					}).then(() => {
						window.location.href = `tel:${tel}`;
					}).catch(() => {});
				} else {
					// 都没有，显示提示
					this.$message.warning('暂未设置售后服务');
				}
			}
		}
	}
</script>

<style scoped>
	.float-btns{
		position: fixed;
		bottom: 20px;
		right: 20px;
		padding: 10px;
		text-align: center;
		z-index: 990;
	}
	.float-action-btn{
		display: flex;
		justify-content: center;
		align-items: center;
		width: 60px;
		height: 60px;
		background-color: #fff;
		cursor: pointer;
	}
	.float-action-btn img{
		width: 30px;
		height: 30px;
	}
	.top-btn{
		margin-top: 10px;
	}
	.float-btn-border{
		border: solid 1px #f9f9f9;
		box-shadow: 2px 3px 5px 0px #d2d2d2;
		border-radius: 2px;
	}
</style>
